module.exports = __webpack_public_path__ + "img/1.0e7f8d87.png";